import {Injectable, inject} from '@angular/core';
import {DragulaService, Group} from 'ng2-dragula';
import {DragulaWithOptions} from 'src/app/shared/models/dragula.interface';

@Injectable({
  providedIn: 'root'
})
export class DragulaConfigurationService {
  private dragulaService = inject(DragulaService);

  public createGroup<T>({groupName, ...options}: DragulaWithOptions<T>): Group {
    const group = this.dragulaService.find(groupName);

    if (group) {
      group.options = options;

      return group;
    }

    return this.dragulaService.createGroup(groupName, options);
  }
}
